import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { appRoutes } from './routes';
import Scale from './Scale';

interface IProps {
    isAuthenticated: boolean;
}

export const PrivateRoute: React.FC<IProps> = ({ isAuthenticated }) => {
    const location = useLocation();
    return isAuthenticated ? (
        <>
            <Outlet />
            {/* <Scale /> */}
        </>
    ) : (
        <Navigate to={`/${appRoutes.AUTH.LOGIN}`} state={{ from: location }} replace />
    );
};
